import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Form, Row } from 'react-bootstrap';
import {logout, update} from '../actions/userActions';
import { USER_UPDATE_PROFILE_RESET } from '../constants/userConstants';
import { listDetails } from '../actions/userActions';
import Loader from '../components/Loader';
import Message from '../components/Message';

const ProfileScreen = ({ history, match, language, t }) => {
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;

    const userDetails = useSelector((state) => state.userDetails);
    const { loading, user } = userDetails;

    const userUpdate = useSelector((state) => state.userUpdate);
    const { success, error } = userUpdate;

    const dispatch = useDispatch();

    const [errors, setErrors] = useState({
        password: '',
        orgName: '',
        mainAct: '',
        taxNum: '',
        regNum: '',
        city: '',
        zip: '',
        address: '',
        houseNum: '',
        country: '',
        lastName: '',
        firstName: '',
        mothersName: '',
        nationality: '',
        birthplace: '',
        birthday: '',
        contactAddress: '',
        contactEmail: '',
        contactPhone: '',
    });
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [orgName, setOrgName] = useState('');
    const [mainAct, setMainAct] = useState('');
    const [taxNum, setTaxNum] = useState('');
    const [regNum, setRegNum] = useState('');
    const [city, setCity] = useState('');
    const [zip, setZip] = useState('');
    const [address, setAddress] = useState('');
    const [houseNum, setHouseNum] = useState('');
    const [country, setCountry] = useState('');
    const [lastName, setLastName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [mothersName, setMothersName] = useState('');
    const [nationality, setNationality] = useState('');
    const [birthplace, setBirthplace] = useState('');
    const [birthday, setBirthday] = useState('');
    const [contactAddress, setContactAddress] = useState('');
    const [contactEmail, setContactEmail] = useState('');
    const [contactPhone, setContactPhone] = useState('');

    useEffect(() => {
        if (!userInfo) {
            history.push('/login');
        }
    }, [history, userInfo]);

    useEffect(()=>{
        if(error && error.includes('Not authorized')){
            dispatch(logout());
            history.push('/login');
        }
    },[error]);

    useEffect(() => {
        if (
            !user ||
            !user.email ||
            success ||
            error ||
            user._id !== userInfo._id
        ) {
            if(error && error.includes('Not authorized')){
                history.push('/login');
            }
            dispatch({ type: USER_UPDATE_PROFILE_RESET });
            dispatch(listDetails(match.params.id));
        } else if (
            user.email &&
            (!user.organization || !user.contact || !user.headquarter)
        ) {
        } else {
            setEmail(user.email);
            setOrgName(user.organization.orgName);
            setMainAct(user.organization.mainAct);
            setTaxNum(user.organization.taxNum);
            setRegNum(user.organization.regNum);
            setCountry(user.headquarter.country);
            setZip(user.headquarter.zip);
            setCity(user.headquarter.city);
            setAddress(user.headquarter.address);
            setHouseNum(user.headquarter.houseNum);
            setFirstName(user.contact.firstName);
            setLastName(user.contact.lastName);
            setMothersName(user.contact.mothersName);
            setNationality(user.contact.nationality);
            setBirthplace(user.contact.birthplace);
            setBirthday(user.contact.birthday);
            setContactAddress(user.contact.contactAddress);
            setContactEmail(user.contact.contactEmail);
            setContactPhone(user.contact.contactPhone);
        }
    }, [dispatch, user, match]);

    const submitProfileData = (e) => {
        e.preventDefault();
        const profileData = {
            _id: user._id,
            email: email,
            password: password,
            organization: {
                orgName: orgName,
                mainAct: mainAct,
                taxNum: taxNum,
                regNum: regNum,
            },
            headquarter: {
                country: country,
                zip: zip,
                city: city,
                address: address,
                houseNum: houseNum,
            },
            contact: {
                firstName: firstName,
                lastName: lastName,
                mothersName: mothersName,
                nationality: nationality,
                birthplace: birthplace,
                birthday: birthday,
                contactAddress: contactAddress,
                contactEmail: contactEmail,
                contactPhone: contactPhone,
            },
        };
        dispatch(update(profileData));
        setPassword('');
    };

    return (
        <div>
            {loading ? (
                <Loader />
            ) : error ? (
                <Message variant='danger'>{error}</Message>
            ) : (
                <>
                    {success && (
                        <Message variant='success'>{t('profile_saved')}</Message>
                    )}
                </>
            )}

            <Form onSubmit={submitProfileData}>
                <Row
                    style={{
                        marginTop: '5px',
                        backgroundColor: '#ececec',
                        padding: '5px',
                    }}
                >
                    <div style={{ width: '100%', padding: '10px' }}>
                        <h5>{t('profile_registration_data')}:</h5>
                    </div>
                    <Col sm={12} md={6}>
                        <Form.Group controlId='email'>
                            <Form.Label>{t('profile_email')}</Form.Label>
                            <Form.Control
                                type='email'
                                placeholder={t('profile_email_description')}
                                value={email}
                                required
                                onChange={(event) => {
                                    setEmail(event.target.value);
                                }}
                            />
                        </Form.Group>
                    </Col>
                    <Col sm={12} md={6}>
                        <Form.Group controlId='password'>
                            <Form.Label>{t('profile_password')}</Form.Label>
                            <Form.Control
                                type='password'
                                placeholder={t('profile_password')}
                                value={password}
                                required
                                onChange={(e) => setPassword(e.target.value)}
                                isInvalid={errors.password !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.password}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>
                <Row
                    style={{
                        marginTop: '5px',
                        backgroundColor: '#ececec',
                        padding: '5px',
                    }}
                >
                    <div style={{ width: '100%', padding: '10px' }}>
                        <h5>{t('profile_organization_data')}:</h5>
                    </div>
                    <Col sm={12} md={6}>
                        <Form.Group controlId='orgName'>
                            <Form.Label>{t('profile_organization_name')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder={t('profile_organization_name')}
                                value={orgName}
                                required
                                onChange={(e) => setOrgName(e.target.value)}
                                isInvalid={errors.orgName !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.orgName}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId='mainAct'>
                            <Form.Label>{t('profile_organization_main_activity')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder={t('profile_organization_main_activity')}
                                value={mainAct}
                                required
                                onChange={(e) => setMainAct(e.target.value)}
                                isInvalid={errors.mainAct !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.mainAct}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col sm={12} md={6}>
                        <Form.Group controlId='taxNum'>
                            <Form.Label>{t('profile_organization_tax_number')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder={t('profile_organization_tax_number')}
                                value={taxNum}
                                required
                                onChange={(e) => setTaxNum(e.target.value)}
                                isInvalid={errors.taxNum !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.taxNum}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId='regNum'>
                            <Form.Label>{t('profile_organization_registry_number')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder={t('profile_organization_registry_number')}
                                value={regNum}
                                onChange={(e) => setRegNum(e.target.value)}
                                isInvalid={errors.regNum !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.regNum}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>
                <Row
                    style={{
                        marginTop: '5px',
                        backgroundColor: '#ececec',
                        padding: '5px',
                    }}
                >
                    <div style={{ width: '100%', padding: '10px' }}>
                        <h5>{t('profile_headquarters')}:</h5>
                    </div>
                    <Col sm={12} md={6}>
                        <Form.Group controlId='country'>
                            <Form.Label>{t('profile_country')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder='Ország'
                                value={t('profile_country')}
                                required
                                onChange={(e) => setCountry(e.target.value)}
                                isInvalid={errors.country !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.country}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId='zip'>
                            <Form.Label>{t('profile_zip_code')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder={t('profile_zip_code')}
                                value={zip}
                                required
                                onChange={(e) => setZip(e.target.value)}
                                isInvalid={errors.zip !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.zip}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId='city'>
                            <Form.Label>{t('profile_city')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder={t('profile_city')}
                                value={city}
                                required
                                onChange={(e) => setCity(e.target.value)}
                                isInvalid={errors.city !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.city}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col sm={12} md={6}>
                        <Form.Group controlId='address'>
                            <Form.Label>{t('profile_address')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder={t('profile_address')}
                                value={address}
                                required
                                onChange={(e) => setAddress(e.target.value)}
                                isInvalid={errors.address !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.address}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId='houseNum'>
                            <Form.Label>{t('profile_street_number')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder={t('profile_street_number')}
                                value={houseNum}
                                required
                                onChange={(e) => setHouseNum(e.target.value)}
                                isInvalid={errors.houseNum !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.houseNum}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>
                <Row
                    style={{
                        marginTop: '5px',
                        backgroundColor: '#ececec',
                        padding: '5px',
                    }}
                >
                    <div style={{ width: '100%', padding: '10px' }}>
                        <h5>{t('profile_representative_data')}:</h5>
                    </div>
                    <Col sm={12} md={6}>
                        <Form.Group controlId='lastName'>
                            <Form.Label>{t('profile_last_name')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder={t('profile_last_name')}
                                value={lastName}
                                required
                                onChange={(e) => setLastName(e.target.value)}
                                isInvalid={errors.lastName !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.lastName}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId='firstName'>
                            <Form.Label>{t('profile_first_name')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder={t('profile_first_name')}
                                value={firstName}
                                required
                                onChange={(e) => setFirstName(e.target.value)}
                                isInvalid={errors.firstName !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.firstName}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId='mothersName'>
                            <Form.Label>{t('profile_mothers_name')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder={t('profile_mothers_name')}
                                value={mothersName}
                                required
                                onChange={(e) => setMothersName(e.target.value)}
                                isInvalid={errors.mothersName !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.mothersName}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId='nationality'>
                            <Form.Label>{t('profile_nationality')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder={t('profile_nationality')}
                                value={nationality}
                                required
                                onChange={(e) => setNationality(e.target.value)}
                                isInvalid={errors.nationality !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.nationality}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId='birthplace'>
                            <Form.Label>{t('profile_birth_place')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder={t('profile_birth_place')}
                                value={birthplace}
                                required
                                onChange={(e) => setBirthplace(e.target.value)}
                                isInvalid={errors.birthplace !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.birthplace}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col sm={12} md={6}>
                        <Form.Group controlId='birthday'>
                            <Form.Label>{t('profile_birth_date')}</Form.Label>
                            <Form.Control
                                type='date'
                                value={birthday}
                                required
                                onChange={(e) => setBirthday(e.target.value)}
                                isInvalid={errors.birthday !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.birthday}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId='contactAddress'>
                            <Form.Label>{t('profile_representative_address')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder={t('profile_representative_address')}
                                value={contactAddress}
                                required
                                onChange={(e) =>
                                    setContactAddress(e.target.value)
                                }
                                isInvalid={errors.contactAddress !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.contactAddress}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId='contactEmail'>
                            <Form.Label>{t('profile_representative_email')}</Form.Label>
                            <Form.Control
                                type='email'
                                placeholder={t('profile_representative_email')}
                                value={contactEmail}
                                required
                                onChange={(e) =>
                                    setContactEmail(e.target.value)
                                }
                                isInvalid={errors.contactEmail !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.contactEmail}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId='contactPhone'>
                            <Form.Label>{t('profile_representative_phone_number')}</Form.Label>
                            <Form.Control
                                type='text'
                                placeholder={t('profile_representative_phone_number')}
                                value={contactPhone}
                                required
                                onChange={(e) =>
                                    setContactPhone(e.target.value)
                                }
                                isInvalid={errors.contactPhone !== ''}
                            />
                            <Form.Control.Feedback type='invalid'>
                                {errors.contactPhone}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='d-flex justify-content-center'>
                    <Button
                        className='m-2'
                        variant='light'
                        style={{ border: '2px solid' }}
                        onClick={() => history.goBack()}
                    >
                        {t('button_cancel')}
                    </Button>
                    <Button className='m-2' type='submit' variant={'success'}>
                        {t('button_save')}
                    </Button>
                </Row>
            </Form>
            {loading ? (
                <Loader />
            ) : error ? (
                <Message variant='danger'>{error}</Message>
            ) : (
                <>
                    {success && (
                        <Message variant='success'>{t('profile_saved')}</Message>
                    )}
                </>
            )}
        </div>
    );
};

export default ProfileScreen;
